import {
  HANDLE_LOGOUT,
  SET_EMAIL,
  SET_FIRST_NAME,
  SET_INFO,
  SET_LAST_NAME,
  SET_USER,
  SIDEBAR_STATUS,
  TOGGLE_SCALED_DASHBOARD,
} from './types'

const user = localStorage.getItem('user')
  ? JSON.parse(localStorage.getItem('user'))
  : null

const initialState = {
  isAuthenticated: user ? true : false,
  user,
  sidebarShowing: true,
  scaledDashboard: false,
}

const userReducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SET_USER:
      return {
        ...state,
        user: payload,
        isAuthenticated: true,
      }
    case SET_INFO:
      return {
        ...state,
        user: payload,
      }

    case SET_FIRST_NAME:
      return {
        ...state,
        user: {
          ...state.user,
          first_name: payload,
        },
      }

    case SET_LAST_NAME:
      return {
        ...state,
        last_name: payload,
      }
    case SET_EMAIL:
      return {
        ...state,
        email: payload,
      }
    case HANDLE_LOGOUT:
      return {
        state: payload,
      }
    case SIDEBAR_STATUS:
      return {
        ...state,
        sidebarShowing: payload,
      }
    case TOGGLE_SCALED_DASHBOARD:
      return {
        ...state,
        scaledDashboard: payload,
      }
    default:
      return state
  }
}

export default userReducer
